<h1 mat-dialog-title>
  {{ injectData.dialogTitle }}
</h1>
<form #form="ngForm" [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.name' | translate }}</mat-label>
        <input matInput [formControl]="addEditForm.controls.name" />
        <mat-error [control]="addEditForm.controls.name"></mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.apiBaseUrl' | translate }}</mat-label>
        <input matInput [formControl]="addEditForm.controls.apiBaseUrl" />
        <mat-error [control]="addEditForm.controls.apiBaseUrl"></mat-error>
      </mat-form-field>

      <mat-dropdown
        [configurationInput]="authenticationTypeDropdownSettings"
        [options]="authenticationStrategyDropdownOptions"
        [formControl]="addEditForm.controls.strategy"
        [isFormSubmitted]="form.submitted"
      >
      </mat-dropdown>

      @switch (selectedAuthenticationType()) {
        @case (EDataSourceAuthenticationType.basic) {
          <mat-form-field appearance="outline">
            <mat-label>{{ 'field.apiKey' | translate }}</mat-label>
            <input
              matInput
              [type]="isInputMasked.apiKey ? 'password' : 'text'"
              [formControl]="addEditForm.controls.apiKey"
            />
            <button mat-icon-button matSuffix [type]="'button'" (click)="isInputMasked.apiKey = !isInputMasked.apiKey">
              <mat-icon>{{ isInputMasked.apiKey ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-hint *ngIf="injectData.editData">{{ 'field.leaveBlankIfNoChangeDisclaimer' | translate }}</mat-hint>
            <mat-error [control]="addEditForm.controls.apiKey"></mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>{{ 'field.apiSecret' | translate }}</mat-label>
            <input
              matInput
              [type]="isInputMasked.apiSecret ? 'password' : 'text'"
              [formControl]="addEditForm.controls.apiSecret"
            />
            <button
              mat-icon-button
              matSuffix
              [type]="'button'"
              (click)="isInputMasked.apiSecret = !isInputMasked.apiSecret"
            >
              <mat-icon>{{ isInputMasked.apiSecret ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-hint *ngIf="injectData.editData">{{ 'field.leaveBlankIfNoChangeDisclaimer' | translate }}</mat-hint>
            <mat-error [control]="addEditForm.controls.apiSecret"></mat-error>
          </mat-form-field>
        }
      }
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit">
      {{ injectData.submitButtonText }}
    </button>
  </mat-dialog-actions>
</form>
